import Qualido from "../../Assets/Qualido.png";
import Tweeter from "../../Assets/Tweeter.png";
import EnvironmentApp from "../../Assets/EnvironmentApp.png";
// import Codebix from "../../Assets/Codebix.png";
import Wolnut from "../../Assets/Wolnut.png";
import Code from "../../Assets/Code.png";
import ContactsApp from "../../Assets/ContactsApp.png";
import TextUtils from "../../Assets/TextUtils.png";
import FormValidator from "../../Assets/FormValidator.png";
import BijliWheels from "../../Assets/BijliWheels.png";
import VideoPlaylist from "../../Assets/VideoPlaylist.png";
import InteractiveCard from "../../Assets/InteractiveCard.png";
import Lernx from "../../Assets/Lernx.png";
import NextcallerWeb from "../../Assets/NextcallerWeb.png";
import RunnerDrop from "../../Assets/RunnerDrop.png";
import NewsDaily from "../../Assets/NewsDaily.png";
import Fincoin from "../../Assets/Fincoin.png";
import Calculator from "../../Assets/Calculator.png";
import Clock from "../../Assets/Clock.png";
import NavPic from "../../Assets/NavPic.png";
import SignInPic from "../../Assets/SignInPic.png";

export const projectsData = [
  {
    id: 1,
    title: "Qualido",
    image: Qualido,
    description:
      "An e-commerce website to deliver quality products at your door.",
    githubUrl: "",
    url: "https://qualido.netlify.app",
  },
  {
    id: 2,
    title: "Tweeter",
    image: Tweeter,
    description:
      "Twitter Clone built with MERN Stack with all basic functionalities including Dark & Light modes.",
    githubUrl: "https://github.com/Vivek3072/Twitter-Clone",
    url: "https://twitter-clone-zwb6.onrender.com/",
  },
  {
    id: 3,
    title: "Environment App",
    image: EnvironmentApp,
    description: "Contributed in both F/E & B/E in this project.",
    githubUrl: "https://github.com/gdscnitp/Environmental-Awareness-App",
    url: "https://environmental-awareness-app.vercel.app",
  },
  // {
  //   id: 4,
  //   title: "Codebix",
  //   image: Codebix,
  //   description:
  //     "Created this website, deployed on AWS S3 and also connected a SSL certificate using AWS CloudFront.",
  //   githubUrl: "",
  //   url: "https://codebix.in",
  // },
  {
    id: 5,
    title: "Wolnut",
    image: Wolnut,
    description:
      "Created this website, deployed on AWS S3 and also connected a SSL certificate using AWS CloudFront.",
    githubUrl: "",
    url: "https://wolnut.in",
  },
  {
    id: 6,
    title: "कोड.com",
    image: Code,
    description:
      "A multilingual coding platform with courses, quizzes, and assignments.",
    githubUrl: "",
    url: "http://xn--11by0j.com/",
  },
  {
    id: 7,
    title: "Contacts App",
    image: ContactsApp,
    description: "A basic contacts app backend to create personal contacts.",
    githubUrl: "https://github.com/Vivek3072/Contacts-app-backend",
    url: "",
  },
  {
    id: 8,
    title: "TextUtils",
    image: TextUtils,
    description: "A text editor app to make changes with your text.",
    githubUrl: "https://github.com/Vivek3072/TextUtils",
    url: "https://text-helper-app.netlify.app/",
  },
  {
    id: 9,
    title: "Form Validator",
    image: FormValidator,
    description: "A form validator built with ReactJS and react-hook-form.",
    githubUrl: "https://github.com/Vivek3072/form-validation-in-react",
    url: "https://react-form-validator.onrender.com/",
  },
  {
    id: 10,
    title: "BijliWheels",
    image: BijliWheels,
    description: "Designed and developed this freelancing project.",
    githubUrl: "",
    url: "https://bijli-wheels.netlify.app/",
  },
  {
    id: 11,
    title: "Video Playlist",
    image: VideoPlaylist,
    description:
      "A video player app, can be used for any online tutorial/course playlist website.",
    githubUrl: "https://github.com/Vivek3072/Video-playlist-app",
    url: "https://video-playlist-app.netlify.app/",
  },
  {
    id: 12,
    title: "Interactive Card",
    image: InteractiveCard,
    description:
      "A beautiful credit card where you can fill and see card details.",
    githubUrl: "https://github.com/Vivek3072/Interactive-card-form",
    url: "https://interactive-form-cards.netlify.app/",
  },
  {
    id: 13,
    title: "Lernx",
    image: Lernx,
    description: "Created this website under internship at Lernx.",
    githubUrl: "",
    url: "https://lernx.io/",
  },
  {
    id: 14,
    title: "Nextcaller",
    image: NextcallerWeb,
    description:
      "Nextcaller's official website built with Namecheap website builder.",
    githubUrl: "",
    url: "https://nextcaller.ai/",
  },
  {
    id: 15,
    title: "RunnerDrop",
    image: RunnerDrop,
    description: "A simple fun game with a good message to save water.",
    githubUrl: "https://github.com/Vivek3072/Runner-Drop",
    url: "https://runner-drop.netlify.app/",
  },
  {
    id: 16,
    title: "NewsDaily",
    image: NewsDaily,
    description: "A news app which fetches data from NEWSAPI.",
    githubUrl: "https://github.com/Vivek3072/NewsDaily",
    url: "",
  },
  {
    id: 17,
    title: "Fincoin",
    image: Fincoin,
    description: "Web-App that deals with cryptos & their trade.",
    githubUrl: "https://github.com/Vivek3072/Fincoin-Website",
    url: "",
  },
  {
    id: 18,
    title: "Calculator",
    image: Calculator,
    description: "A simple calculator with an awesome design theme.",
    githubUrl: "https://github.com/Vivek3072/Calculator",
    url: "",
  },
  {
    id: 19,
    title: "Clock",
    image: Clock,
    description: "A clock for you to see time in a beautiful way.",
    githubUrl: "https://github.com/Vivek3072",
    url: "",
  },
  {
    id: 20,
    title: "Navbar",
    image: NavPic,
    description: "A responsive navbar made using HTML & CSS.",
    githubUrl: "https://github.com/Vivek3072/Responsive-Navbar",
    url: "",
  },
  {
    id: 21,
    title: "SignIn/Up",
    image: SignInPic,
    description: "An app with cool login/signup page design.",
    githubUrl: "https://github.com/Vivek3072/",
    url: "",
  },
];
